<template>
    <div class="nav-tabs" ui-col col=12>
        <ul class="tab-header" ui-row around>
            <li :class="tabClass(index, header.icon)" v-for="(header, index) in tabsHeader" :key="index" @click.stop="openTab(index)" mb=0> {{header.title}} </li>
        </ul>
        <div class="divider"> </div>
        <div class="tabs-content" :style="tabContentStyle" pt=1 pb=1>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        maxHeight: {
            type: String,
            default: null
        }
    },
    data: function(){
        return {
            tabOpenedIndex: 0,
        }
    },
    computed: {
        tabs(){
            return this.$slots.default.filter(slot=> slot.componentOptions && slot.componentOptions.tag == 'vue-tab');
        },
        tabsHeader(){
            return this.tabs.map(function(tab){
                return {
                    'title': tab.componentOptions.propsData.title,
                    'icon': tab.componentOptions.propsData.icon
                }
            });
        },
        tabContentStyle(){
            var _style = {}
            if (this.maxHeight){
                _style['max-height'] = this.maxHeight;
            }
            return _style
        }
    },
    methods: {
        openTab(index){
            if(index != this.tabOpenedIndex){
                this.tabOpenedIndex = index;
            }
        },
        tabClass(index, icon=null){
            return {
                'pointer' : true,
                'tab': true,
                'inactive-tab': this.tabOpenedIndex != index,
                'active-tab': this.tabOpenedIndex == index,
                [icon]: icon != null
            }
        },
        changeTab(toIndex, fromIndex){
            this.tabs[fromIndex].componentInstance.$data.active = false;
            this.tabs[toIndex].componentInstance.$data.active = true;
        }
    },
    watch: {
        tabOpenedIndex(newValue, oldValue){
            this.changeTab(newValue, oldValue);
        }
    }
}
</script>